import { i18n } from "@next-core/i18n";
export function registerAppI18n(_ref) {
  let {
    app,
    meta
  } = _ref;
  if (meta !== null && meta !== void 0 && meta.i18n) {
    // Prefix to avoid conflict between brick package's i18n namespace.
    const i18nNamespace = getI18nNamespace("app", app.id);
    // Support any language in `meta.i18n`.
    const languages = [];
    Object.entries(meta.i18n).forEach(_ref2 => {
      let [lang, resources] = _ref2;
      i18n.addResourceBundle(lang, i18nNamespace, resources);
      languages.push(lang);
    });
    return () => {
      for (const lang of languages) {
        i18n.removeResourceBundle(lang, i18nNamespace);
      }
    };
  }
}
export function getI18nNamespace(type, id) {
  return `${type}/${id}`;
}
//# sourceMappingURL=registerAppI18n.js.map